<script>
    import LySection from './LySection.svelte';

    /**
     * @type {{
     *     tag?: string,
     *     mt?: number | boolean | string,
     *     mb?: number | boolean | string,
     *     wrapper?: boolean | string,
     *     center?: boolean | string,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { tag = 'section', mt = 0, mb = 0, wrapper = false, center = false, children } = $props();
</script>

<LySection {tag} {mt} {mb} {wrapper} {center} addClass="grid grid-cols-2 gap-4 justify-items-start items-start">
    {@render children?.()}
</LySection>
